import React from 'react'
import { Box } from '@mui/material'
import { EmtIcon, EmtTooltip, EmtTypography } from 'emt-components-v2'

// Descriptions use the EmtMarkdown list syntax: each `--item--` is rendered as a bullet point
export const SECURITY_FEES_INCLUDED =
  "--Ligne d’assistance vétérinaire 24h/24-- --Garantie Dommages (jusqu'à 3000 €)-- --Garantie Frais Vétérinaires (jusqu'à 3000€)-- --Suivi quotidien de notre part auprès des pet sitters--"

export const PRICE_INCLUDED = `--Rémunération du pet sitter-- ${SECURITY_FEES_INCLUDED}`

export const PRO_PRICE_INCLUDED =
  "--Votre rémunération-- --Ligne d’assistance vétérinaire 24h/24-- --Garantie Dommages (jusqu'à 3000 €)-- --Garantie Frais Vétérinaire (jusqu'à 3 000 €)--"

interface InfoTooltipProps {
  title: React.ReactNode
  description: React.ReactNode
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({ title, description }) => (
  <EmtTooltip
    title={
      <Box>
        <EmtTypography variant="body2" fontWeight="700">
          {title}
        </EmtTypography>
        <EmtTypography variant="caption" sx={{ '& ul': { listStyleType: 'disc', paddingLeft: '20px' } }}>
          {description}
        </EmtTypography>
      </Box>
    }
  >
    <EmtIcon className="emt-info-circle-1" />
  </EmtTooltip>
)

export const PriceIncludedTooltip: React.FC<{ pro?: boolean }> = ({ pro }) => (
  <InfoTooltip title="Inclut : " description={pro ? PRO_PRICE_INCLUDED : PRICE_INCLUDED} />
)
